import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService, ApplicationMode } from './core/services/app.service';

@Injectable({
  providedIn: 'root',
})
export class OnlineGuard {
  constructor(
    private appService: AppService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.appService.getMode().pipe(
      map((mode) => {
        if (mode !== ApplicationMode.ONLINE) {
          this.router.navigateByUrl('/offline');
          return false;
        }

        return true;
      }),
    );
  }
}
